import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';

import { getResourceTo, getTWComplianceByStatusClass } from 'react/utils/utils';
import { TableHeader, TableItem } from './styles';

function TimeWindowsTable(props) {
  const { stopData, isBlocked } = props;
  const { status, statusClass, tw } = stopData;

  const twCompliance = useMemo(() => {
    const FIRST_TIME_WINDOW_INDEX = 0;

    const firstTimeWindow = tw[FIRST_TIME_WINDOW_INDEX];
    const hasOverrideTw = !!firstTimeWindow?.override;
    const finalTimeWindow = hasOverrideTw ? firstTimeWindow.override : firstTimeWindow?.actual;

    const { icon, resource, twStatus } = getTWComplianceByStatusClass(statusClass);

    return {
      timeWindow: finalTimeWindow?.timeWindow,
      status: twStatus,
      icon,
      resource,
    };
  }, [statusClass]);

  return (
    <Flex flexDirection="column">
      <TableHeader>
        <span>{getResourceTo('Stop.popup.tw.timeWindows')}</span>
        <span>
          {`${getResourceTo('Stop.popup.tw')} 1`}
        </span>
        <span>
          {`${getResourceTo('Stop.popup.tw')} 2`}
        </span>
      </TableHeader>
      <TableItem>
        <span>{getResourceTo('Stop.popup.timeInterval')}</span>
        {!twCompliance.timeWindow ? (
          <>
            <span>--:-- - --:--</span>
            <span>--:-- - --:--</span>
          </>
        ) : (
          <>
            <span>
              {twCompliance.timeWindow.tw1.open} - {twCompliance.timeWindow.tw1.close}
            </span>
            <span>
              {twCompliance.timeWindow.tw2.open} - {twCompliance.timeWindow.tw2.close}
            </span>
          </>
        )}
      </TableItem>
      {!isBlocked && (
        <TableItem className="col-2">
          <span>{getResourceTo('Stop.popup.twCompliance')}</span>
          <Flex alignItems="center" gap={2}>
            <img
              src={twCompliance.icon}
              alt={`Stop status Icon - ${status}`}
              className="icon-delivery"
            />
            <Text size="xxs" asChild>
              <span>
                {getResourceTo(twCompliance.resource)}
              </span>
            </Text>
          </Flex>
        </TableItem>
      )}
    </Flex>
  );
};

TimeWindowsTable.propTypes = {
  stopData: PropTypes.object.isRequired,
  isBlocked: PropTypes.bool.isRequired
};

export default TimeWindowsTable;
